import config from '@/config'
import axios from 'axios'

const instance = axios.create({
  baseURL: `${config.getConfig('serverUrl')}api/payment-gateway`,
  timeout: 30000
})

export const paymentGatewayApi = {
  getPaymentGateway: (request) => {
    const { config } = request
    return instance.get(`/shop/filter`, config)
  }
}
